import { render } from "./SortTableMailStatusCellComponent.vue?vue&type=template&id=184ac66c&scoped=true"
import script from "./SortTableMailStatusCellComponent.vue?vue&type=script&lang=js"
export * from "./SortTableMailStatusCellComponent.vue?vue&type=script&lang=js"

import "./SortTableMailStatusCellComponent.vue?vue&type=style&index=0&id=184ac66c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184ac66c"]])

export default __exports__